import { useEffect, useState } from 'react'
import { useReducedMotion } from 'framer-motion'

type MotionPreferences = {
  /** True when the user asked for reduced motion at the OS level. */
  reduced: boolean
  /** True on small screens, where heavy scroll effects are dialled back. */
  isMobile: boolean
  /** Multiplier for parallax distances: 0 = off, 0.4 = gentle (mobile), 1 = full. */
  parallax: number
  /** True when pointer-driven tilt should be enabled. */
  tiltEnabled: boolean
}

export function useMotionPreferences(): MotionPreferences {
  const reduced = useReducedMotion() ?? false
  const [isMobile, setIsMobile] = useState(false)
  const [finePointer, setFinePointer] = useState(true)

  useEffect(() => {
    const smallScreen = window.matchMedia('(max-width: 767px)')
    const pointer = window.matchMedia('(hover: hover) and (pointer: fine)')

    const sync = () => {
      setIsMobile(smallScreen.matches)
      setFinePointer(pointer.matches)
    }

    sync()
    smallScreen.addEventListener('change', sync)
    pointer.addEventListener('change', sync)
    return () => {
      smallScreen.removeEventListener('change', sync)
      pointer.removeEventListener('change', sync)
    }
  }, [])

  return {
    reduced,
    isMobile,
    parallax: reduced ? 0 : isMobile ? 0.4 : 1,
    tiltEnabled: !reduced && finePointer,
  }
}
